// extracted by mini-css-extract-plugin
export default {"schoolHeader":"school-header-tab_schoolHeader__+Vskn","image":"school-header-tab_image__V204Y","content":"school-header-tab_content__jQLzU","name":"school-header-tab_name__TtZIq"};